module.exports = __webpack_public_path__ + "static/media/map-thumb.02b9854e.png";